import environment from 'environment';
import { getSessionToken } from 'util/parseSelectors';
import request from 'util/superagent';

const {
  ZENDESK_BASE_URL,
  GORGIAS_BASE_URL,
  SALESFORCE_BASE_URL,
  SALESFORCE_CHAT_V2_BASE_URL,
  GLADLY_BASE_URL,
  INTERCOM_BASE_URL,
  GENESYS_BASE_URL,
} = environment.integrations;

export const zendeskGetQuery = getRequest(ZENDESK_BASE_URL);
export const zendeskPostPutQuery = postPutRequest(ZENDESK_BASE_URL);

export const gorgiasGetQuery = getRequest(GORGIAS_BASE_URL);
export const gorgiasPostQuery = postRequest(GORGIAS_BASE_URL);

export const salesforceGetQuery = getRequest(SALESFORCE_BASE_URL);
export const salesforcePostQuery = postRequest(SALESFORCE_BASE_URL);

export const salesforceChatV2PostQuery = postRequest(SALESFORCE_CHAT_V2_BASE_URL);

export const intercomGetRequest = getRequest(INTERCOM_BASE_URL);

export const gladlyGetRequest = getRequest(GLADLY_BASE_URL);
export const gladlyPostRequest = postRequest(GLADLY_BASE_URL);

export const genesysGetRequest = getRequest(GENESYS_BASE_URL);

export function postRequest(base_url, timeout = {}) {
  return async (endpoint, payload = {}, query = {}) => {
    const sessionToken = getSessionToken();

    const base = request.post(`${base_url}${endpoint}`);

    if (timeout) {
      base.timeout(timeout);
    }

    const response = await base.set('x-session-token', sessionToken).query(query).send(payload);

    return response.body;
  };
}

export function getRequest(base_url, timeout = null) {
  return async (endpoint, query = {}, bodyField = null) => {
    const sessionToken = getSessionToken();

    const base = request.get(`${base_url}${endpoint}`);

    if (timeout) {
      base.timeout(timeout);
    }

    const response = await base.set('x-session-token', sessionToken).query(query);

    return bodyField ? response.body[bodyField] : response.body;
  };
}

export function postPutRequest(base_url, timeout = null) {
  return async (method, endpoint, payload = {}, query = {}) => {
    const sessionToken = getSessionToken();

    const base = request[method](`${base_url}${endpoint}`);

    if (timeout) {
      base.timeout(timeout);
    }
    const response = await base.set('x-session-token', sessionToken).query(query).send(payload);

    return response.body;
  };
}
